import React from "react";
import "../styles/Tabs.css";

const Tabs = () => {
  return (
    <div className="tabs-container">
      <h1 className="tab">Topics</h1>
      {/* <h1 className="tab">Sounds</h1>
      <h1 className="tab">Breathwork</h1>*/}
    </div>
  );
};

export default Tabs;
